$(function() {
  if ($('div.clock').length > 0) {
    var $hands = $('div.hand')

    window.requestAnimationFrame = window.requestAnimationFrame
                                   || window.mozRequestAnimationFrame
                                   || window.webkitRequestAnimationFrame
                                   || window.msRequestAnimationFrame
                                   || function(f){return setTimeout(f, 1000/60)}


    function updateclock(){
     var curdate = new Date()
     var hour_as_degree = ( curdate.getHours() + curdate.getMinutes()/60 ) / 12 * 360
     var minute_as_degree = curdate.getMinutes() / 60 * 360
     $hands.filter('.hours').css({transform: 'rotate(' + hour_as_degree + 'deg)' })
     $hands.filter('.minutes').css({transform: 'rotate(' + minute_as_degree + 'deg)' })
     //requestAnimationFrame(updateclock)
    }

    requestAnimationFrame(updateclock)
  }
});




